import { createFileRoute } from '@tanstack/react-router';
import { HomeGate } from '@/features/account/shell/HomeGate';
import EditEmailPage from '@/features/account/profile/edit-email';

export const Route = createFileRoute('/perfil/editar/email')({
  component: () => (
    <HomeGate>
      <EditEmailPage />
    </HomeGate>
  ),
});
